export default __webpack_public_path__ + "static/media/admin-login@2x.3a90fc8a.png";